
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car",
      function () {
        return require("private-next-pages/car.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car"])
      });
    }
  